import React from 'react';

import Button from '@components/Button';
import LogoTIWithIconTI from '@components/Images/Rebranding/LogoTIWithIconTI';
import { MORE_SUBMENU_SOCIAL_NAV_ITEMS } from '@components/Nav/navItems';

const Address = () => {
  return (
    <div className="flex flex-col items-center justify-center">
      <LogoTIWithIconTI className="w-[262px]" />
      <div className="my-80 flex justify-center gap-32 sm:w-[175px]">
        {MORE_SUBMENU_SOCIAL_NAV_ITEMS.map(({ icon: Icon, name, ...rest }) => (
          <Button
            className="flex h-[21px] w-[21px] items-center justify-center  hover:border-primary-magenta hover:text-primary-magenta focus:border-primary-magenta focus:text-primary-magenta"
            as="link"
            key={name}
            {...rest}
          >
            <Icon className="h-[21px] fill-black" />
            <span className="sr-only">{name}</span>
          </Button>
        ))}
      </div>
      <address className="flex flex-wrap justify-center gap-64 px-32 text-center font-suisse-neue text-subheadline-sm not-italic sm:flex-nowrap sm:justify-normal sm:gap-[196px] sm:px-0 md:text-subheadline-md">
        <div className="gap-1 flex min-w-[278px] flex-col gap-16 border-0 border-b-2 border-solid border-primary-magenta pb-16">
          <div className="italic">West Coast Bureau</div>
          <div>251 Rhode Island Street</div>
          <div>Suite 107</div>
          <div>San Francisco, CA 94103</div>
        </div>
        <div className="flex min-w-[278px] flex-col gap-16 border-0 border-b-2 border-solid border-primary-magenta pb-16">
          <div className="italic">East Coast Bureau</div>
          <div>20 West 22nd Street</div>
          <div>Suite 1006</div>
          <div>New York, NY 10010</div>
        </div>
      </address>
    </div>
  );
};

export default Address;
